import actions from './actions'

const initialState = {
  isLoading: false,
}

export default function apiLoaderReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
